var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"minus-column minus-column-question"},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"b-tip",attrs:{"title":"You can hide rows by clicking on minuses below. To see them again you can click the 'expand hidden parameters' button below"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }